import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    if (error?.response?.status === 401 && !error.config._retry && !error.config.url?.includes("/auth/")) {
      error.config._retry = true;
      try {
        await axios.post(`${API_BASE}/auth/refresh`, {}, { withCredentials: true });
        return api.request(error.config);
      } catch (e) {
        // fall through
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Errore imprevisto";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join("; ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
}

export default api;
